import { MessageTypes } from '../../home/v1/typings/message-types';

export interface ForwardMsgTypes {
  showFrowardMsgPopup: boolean;
  showSelectMsgToForward: boolean;
}

type ForwardMsgType = (MessageTypes & { statsId: string }) | undefined;

export interface defaultForwardAtomState {
  forwardMsg: ForwardMsgType[];
}

export enum ForwardMsgAction {
  SHOW_MSGS_SELECT_VIEW = 'SHOW_MSGS_SELECT_VIEW',
  SHOW_MSGS_FORWARD_POPUP = 'SHOW_MSGS_FORWARD_POPUP',
  HIDE_MSGS_SELECT_VIEW = 'HIDE_MSGS_SELECT_VIEW',
  HIDE_MSGS_FORWARD_POPUP = 'HIDE_MSGS_FORWARD_POPUP',
  ADD_MSG_TO_FORWARD = 'ADD_MSG_TO_FORWARD',
  RMV_MSG_TO_FORWARD = 'RMV_MSG_TO_FORWARD',
  EMPTY_MSG_TO_FORWARD = 'EMPTY_MSG_TO_FORWARD',
  RESET_FORWARD_MSG_STATE = 'RESET_FORWARD_MSG_STATE',
}

interface AddMsgToForward {
  type: ForwardMsgAction.ADD_MSG_TO_FORWARD;
  data: {
    msg: MessageTypes;
    msgId: string;
  };
}
interface RmvMsgToForward {
  type: ForwardMsgAction.RMV_MSG_TO_FORWARD;
  data: {
    msgId: string;
  };
}
interface EmptyMsgToForward {
  type: ForwardMsgAction.EMPTY_MSG_TO_FORWARD;
}

interface ResetMsgForwardState {
  type: ForwardMsgAction.RESET_FORWARD_MSG_STATE;
}

interface ShowMesgsSelectView {
  type: ForwardMsgAction.SHOW_MSGS_SELECT_VIEW;
  data: {
    msg: MessageTypes;
    msgId: string;
  };
}

interface HideMesgsSelectView {
  type: ForwardMsgAction.HIDE_MSGS_SELECT_VIEW;
}

interface HideMsgsForwardView {
  type: ForwardMsgAction.HIDE_MSGS_FORWARD_POPUP;
}

interface ShowMsgsForwardView {
  type: ForwardMsgAction.SHOW_MSGS_FORWARD_POPUP;
  data?: {
    fromMediaViewer?: boolean;
  };
}

export type ForwardMsgReducerAction =
  | AddMsgToForward
  | EmptyMsgToForward
  | ShowMesgsSelectView
  | HideMesgsSelectView
  | HideMsgsForwardView
  | ShowMsgsForwardView
  | ResetMsgForwardState
  | RmvMsgToForward;
